import { useQuery } from '@tanstack/react-query'
import { useCogfy } from './use-cogfy'
import { GetOperationsQuery } from '@indigohive/cogfy-types/endpoints/getOperations'
import { UUID } from '@indigohive/cogfy-types'

export function useOperations (
  query: GetOperationsQuery & { fieldId?: UUID } = {}
) {
  const cogfy = useCogfy()

  const getOperations = useQuery({
    queryKey: ['getOperationSchemas', query],
    queryFn: ({ signal }) => cogfy.getOperations(query, { signal })
  })

  return getOperations
}
